import localforage from 'localforage'
import $ from 'jquery'

let localforageStoreResources = localforage.createInstance({
  name: 'qm-survey-webapp',
  storeName: 'resources'
})

const initialState = {
  all: [],
  resource: {
    resourceId: null,
    surveyId: null,
    date: null,
    time: null,
    vehicleTypeId: null,
    trailer: null,
    packer: 0,
    fitter: 0,
    porter: 0
  }
}

let state = initialState

const getters = {
  getAllResources: state => state.all,
  getResource: state => state.resource
}

const actions = {
  loadAllResources ({ commit, state }) {
    return new Promise((resolve, reject) => {
      let resources = []
      localforageStoreResources.getItems().then((results) => {
        if (results) {
          for (let result in results) {
            resources.push(JSON.parse(results[result]))
          }
        }
        commit('receiveResources', resources)
        resolve()
      })
    })
  },
  loadResources ({ commit }, surveyId) {
    return new Promise((resolve, reject) => {
      let resources = []
      localforageStoreResources.startsWith('survey-' + surveyId).then(function (results) {
        if (results) {
          $.each(results, function (index, value) {
            resources.push(JSON.parse(value))
          })
        }
        commit('receiveResources', resources)
        resolve()
      }).catch(function (err) {
        console.log(err)
      })
    })
  },
  addResource ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      localforageStoreResources.setItem(payload.storageKey, JSON.stringify(payload.resource)).then(function () {
        commit('addResourceFromStorage', payload.resource)
        resolve()
      })
    })
  },
  updateResource ({ commit }, payload) {
    return new Promise((resolve, reject) => {
      localforageStoreResources.setItem(payload.storageKey, JSON.stringify(payload.resource)).then(function () {
        commit('updateResource', payload.resource)
        resolve()
      })
    })
  },
  importResources ({ commit }, resources) {
    return new Promise((resolve, reject) => {
      commit('clearResourcesState')
      Object.keys(resources).forEach((key, resource) => {
        localforageStoreResources.setItem(key, JSON.stringify(resources[key])).then(() => {
          commit('receiveResource', resource)
        })
      })
      resolve()
    })
  },
  deleteSurveyResources ({ commit, state }, surveyId) {
    return new Promise((resolve, reject) => {
      // get localforage keys of all objs to be deleted
      let keys = []
      localforageStoreResources.iterate((result, key) => {
        result = JSON.parse(result)
        if (result.surveyId === surveyId) {
          keys.push({
            'key': key,
            'id': result.id
          })
        }
      },
      () => {
        // success callback: delete all objs from localforage, resolve once all keys have been processed
        let counter = 0
        keys.forEach((result) => {
          localforageStoreResources.removeItem(String(result.key)).then(() => {
            commit('removeResourceFromState', result.id)
            counter++
            if (counter === keys.length) {
              resolve()
            }
          })
        })
        if (counter === 0) {
          resolve()
        }
      })
    })
  },
  clearResourcesStorage ({ commit }) {
    return new Promise((resolve, reject) => {
      localforageStoreResources.clear().then(() => {
        commit('clearResourcesState')
        resolve()
      })
    })
  }
}

// mutations
const mutations = {
  receiveResources (state, resources) {
    state.all = resources
  },
  receiveResource (state, resource) {
    state.all.push(resource)
  },
  addResourceFromStorage (state, resource) {
    state.all.push(resource)
  },
  updateResource (state, resource) {
    let index = state.all.findIndex(stateResource => Number(stateResource.resourceId) === Number(resource.resourceId))
    state.all[index] = resource
  },
  removeResourceFromState (state, resourceId) {
    let index = state.all.findIndex(x => x.id === resourceId)
    state.all.splice(index, 1)
  },
  clearResourcesState (state) {
    state = initialState
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}




// WEBPACK FOOTER //
// ./src/store/modules/resources.js